export const CREATE_TEMPLATE_REQUEST_STATUS = {
  AWAITING_CREDENTIALS: 'awaiting_credentials',
  PREPARING: 'preparing',
  CANCELLED: 'cancelled'
};

export const isCreateTemplateRequestCancelled = task =>
  task?.status === CREATE_TEMPLATE_REQUEST_STATUS.CANCELLED;

export const isCreateTemplateAwaitingCredentials = task =>
  task?.status === CREATE_TEMPLATE_REQUEST_STATUS.AWAITING_CREDENTIALS;

export const isCreateTemplatePreparing = task =>
  task?.status === CREATE_TEMPLATE_REQUEST_STATUS.PREPARING;

export const isCreateTemplateRequestActive = task =>
  Boolean(task) && !isCreateTemplateRequestCancelled(task);

export const createCreateTemplateRequestTask = ({
  status,
  usersData,
  skipPreparingDialog
} = {}) => ({
  status,
  ...(usersData !== undefined && { usersData }),
  ...(skipPreparingDialog ? { skipPreparingDialog: true } : {})
});
